import axios from "axios";
import { io } from "socket.io-client";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001";
const API = `${API_BASE_URL}/api/chat`;

export const getOrCreateDmApi = (targetUserId) =>
  axios.post(`${API}/conversations/dm`, { targetUserId });

export const getMessagesApi = (conversationId, before) =>
  axios.get(`${API}/conversations/${conversationId}/messages`, {
    params: before ? { before } : {},
  });

export const sendMessageApi = ({ conversationId, text, files }) => {
  const fd = new FormData();
  if (text) fd.append("text", text);
  (files || []).forEach((file, i) => fd.append(`file_${i}`, file));
  return axios.post(`${API}/conversations/${conversationId}/messages`, fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const markReadApi = (conversationId) =>
  axios.post(`${API}/conversations/${conversationId}/read`);

// One shared socket for the whole app session — connected lazily on first
// use (e.g. when the Messages page mounts), same origin as the REST API.
// `token` rides in the handshake (utils/chatSocket.js on the backend rejects
// chat events without a valid one) — same JWT already sitting on the axios
// default header.
let socket = null;
export const getChatSocket = () => {
  if (!socket) {
    const token = axios.defaults.headers.common["Authorization"]?.replace(/^Bearer /, "");
    socket = io(API_BASE_URL, {
      transports: ["websocket"],
      autoConnect: true,
      auth: { token },
    });
  }
  return socket;
};
